<template>
    <div>        
        <div class="cont-box">
            <div class="photo-box">
                <img class="photo" src="@/assets/head-portrait.png" alt="">
                <div class="photo-info">
                    <div class="t1">
                        <div>{{user.username | filterName}}</div>
                        <img class="img" src="@/assets/Level.png" alt="">
                        <div class="level">V{{user.level}}</div>
                    </div>
                    <p class="t2">UID：{{uid}}</p>
                </div>
                <img class="icon" src="@/assets/me-set.png" @click="jump(7)" alt="">
            </div>
            <div class="banner-box">
                <swiper class="swiper" ref="mySwiper" :options="swiperOption">
                    <swiper-slide v-for="(item,index) in wheelImg" :key="index" :data-index="index">
                        <img class="banner" :src="item.img_url" alt="banner">
                        <div class="title ellipse">{{item.title}}</div>
                    </swiper-slide> 
                    <div class="swiper-pagination" slot="pagination"></div>                 
                </swiper> 
            </div>
            <div class="notice-box" v-show="newsArr.length > 0">
                <img class="icon" src="@/assets/assets_Notice.png" alt="">
                <div class="cont ellipse">
                    <swiper class="swiper notice-scroll" ref="mySwiper2" :options="swiperOption2">
                        <swiper-slide class="ellipse" v-for="(item,index) in newsArr" :key="index" :data-index="index">{{item.title}}</swiper-slide>                                        
                    </swiper>
                </div>
                <img class="arrow" src="@/assets/arrow-white.png" alt="">
            </div>
            <div class="zc-wrap">
                <div class="zc-box">
                    <div class="zc-head">
                        <div class="text">{{this.$t('zc.zzczh')}}</div> 
                    </div>
                    <div class="price">
                        <div v-if="!isShow">******</div>
                        <div v-else>{{all_money}}</div> 
                        <div class="small">USDT</div>
                        <img class="icon" src="@/assets/icon_show.png" v-show="isShow" @click.stop="change" alt="">
                        <img class="icon" src="@/assets/icon_hide.png" v-show="!isShow" @click.stop="change" alt="">
                    </div>
                </div>
                <div class="list list2" @click="zcJump(1,'GDCC',btcm_money,(btcm_money * local_currency).toFixed(4))">                            
                    <div class="info-box">       
                        <div class="img-box">
                            <img class="img" src="@/assets/gdcc.png" alt="">
                            <div class="title t2">GDCC</div>
                        </div>                         
                        <div class="price-box">
                            <div class="text1">{{this.$t('zc.xj')}}</div>
                            <div class="text2">{{btcm_money}} GDCC</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">{{this.local_currency}}</div>
                            <div class="text2">{{this.$t('zc.zh')}}{{btcm_money * local_currency | toFixed}} USDT</div>
                        </div>
                    </div> 
                    <img class="arrow" src="@/assets/arrow-white.png" alt="">                          
                </div> 
                <div class="list list3" @click="zcJump(2,'USDT',usdt_money,(usdt_money * 1).toFixed(4))">                            
                    <div class="info-box">    
                        <div class="img-box">
                            <img class="img" src="@/assets/USDT.png" alt="">
                            <div class="title t4">USDT</div>
                        </div>                            
                        <div class="price-box">
                            <div class="text1">{{this.$t('zc.xj')}}</div>
                            <div class="text2">{{usdt_money}} USDT</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">1</div>
                            <div class="text2">{{this.$t('zc.zh')}}{{usdt_money*1 | toFixed}} USDT</div>
                        </div>
                    </div>  
                    <img class="arrow" src="@/assets/arrow-white.png" alt="">                         
                </div>
                <div class="list list4" @click="zcJump(4,'BTC',btc_money,(btc_money * btc).toFixed(4))">                            
                    <div class="info-box"> 
                        <div class="img-box">
                            <img class="img" src="@/assets/BTC.png" alt="">
                            <div class="title t1">BTC</div>
                        </div>
                        <div class="price-box">
                            <div class="text1">{{this.$t('zc.xj')}}</div>
                            <div class="text2">{{btc_money}} BTC</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">{{btc}}</div>
                            <div class="text2">{{this.$t('zc.zh')}}{{btc_money * btc | toFixed}} USDT</div>
                        </div>
                    </div>   
                    <img class="arrow" src="@/assets/arrow-white.png" alt="">                    
                </div> 
                <div class="list list5" @click="zcJump(3,'ETH',eth_money,(eth_money * eth).toFixed(4))">                            
                    <div class="info-box">    
                        <div class="img-box">
                            <img class="img" src="@/assets/ETH.png" alt="">
                            <div class="title eth">ETH</div>
                        </div>                            
                        <div class="price-box">
                            <div class="text1">{{this.$t('zc.xj')}}</div>
                            <div class="text2">{{eth_money}} ETH</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">{{eth}}</div>
                            <div class="text2">{{this.$t('zc.zh')}}{{eth_money*eth | toFixed}} USDT</div>
                        </div>
                    </div>    
                    <img class="arrow" src="@/assets/arrow-white.png" alt="">                       
                </div>  
                <div class="list list6" @click="zcJump(5,'TRX',trx_money,(trx_money * trx).toFixed(4))">                            
                    <div class="info-box">    
                        <div class="img-box">
                            <img class="img" src="@/assets/TRX.png" alt="">
                            <div class="title trx">TRX</div>
                        </div>                            
                        <div class="price-box">
                            <div class="text1">{{this.$t('zc.xj')}}</div>
                            <div class="text2">{{trx_money}} TRX</div>
                        </div>
                        <div class="sl-box">
                            <div class="text1">{{trx}}</div>
                            <div class="text2">{{this.$t('zc.zh')}}{{trx_money*trx | toFixed}} USDT</div>
                        </div>
                    </div>    
                    <img class="arrow" src="@/assets/arrow-white.png" alt="">                       
                </div>                    
            </div>
            <ul class="item-box">                
                <router-link class="item" to="/chongbi" tag="li">{{this.$t('zc.cb')}}</router-link>
                <li class="item" @click="tibi">{{this.$t('zc.tb')}}</li>
                <li class="item" @click="duiHuang">{{this.$t('zc.kjmb')}}</li>  
            </ul>
            <ul class="list-box">   
                <li class="list" @click="jump(4)">
                    <img class="icon" src="@/assets/authentication.png" alt="">
                    <div class="list-text">{{this.$t('user.smrz')}}</div>                    
                </li>
                <li class="list" @click="jump(3)">
                    <img class="icon" src="@/assets/capital.png" alt="">
                    <div class="list-text">{{this.$t('user.zjmx')}}</div>                    
                </li>      
                <li class="list" @click="jump(5)">
                    <img class="icon" src="@/assets/order.png" alt="">
                    <div class="list-text">{{this.$t('user.wddd')}}</div>                    
                </li> 
                <li class="list" @click="sign">
                    <img class="icon" src="@/assets/Sign-in.png" alt="">
                    <div class="list-text">{{this.$t('sign.title3')}}</div>                   
                </li>  
                <li class="list" @click="jump(10)">
                    <img class="icon" src="@/assets/customer-service.png" alt="">
                    <div class="list-text">{{this.$t('kefu.zxkf')}}</div>                   
                </li>    
                <li class="list" @click="jump(6)">
                    <img class="icon" src="@/assets/news.png" alt="">
                    <div class="list-text">{{this.$t('news.title1')}}</div>                    
                </li>                             
            </ul>   
        </div>
        <!-- 实名认证 -->
        <div class="mask" v-show="isMask"></div>
        <div class="alert-wrap2" v-show="isShowSmrz">
            <div class="alert-head">
                {{this.$t('pay.wxts')}}
                <img class="icon" src="@/assets/close.png" @click="smrzClose" alt="">
            </div>
            <div class="tips">{{this.$t('smrz.tip7')}}</div>                
            <div class="btn-box">
                <button class="btn reset" type="button" @click="smrzClose">{{this.$t('duihuang.qx')}}</button>
                <button class="btn sure" type="button" @click="smrzSure">{{this.$t('smrz.qws')}}</button>
            </div>
        </div>
        <!-- 支付设置 -->
        <div class="alert-wrap alert-pay" v-show="isPayShow">
            <div class="alert-head">
                {{this.$t('tips.zfts')}}  
                <img class="close" src="@/assets/close.png"  @click="paySetClose" alt="">                        
            </div>
            <div class="alert-btn" @click="payJump">{{this.$t('wdkj.sure')}}</div>
        </div>
        <!-- 下载弹窗 -->
        <div class="download-box"  v-show="isDownShow">
            <img class="logo" src="@/assets/app-logo.png" alt="">
            <div class="text-box">
                <p class="t1">{{this.$t('download.app')}}</p>
                <p class="t2">{{this.$t('download.t1')}}</p>
            </div>
            <router-link class="btn" tag="div" to="/downLoad">{{this.$t('download.xz')}}</router-link>            
            <img class="btn-close" src="@/assets/close.png" alt="" @click="close">
        </div>    
        <nav-bar navName='user'></nav-bar>
    </div>
</template>
<script>
import navBar from '@/components/NavBar.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

let vm = null;
export default {
    name: 'user',
    data () {
        return {
            isShow: true,
            isSmrz: false,
            isShowSmrz: false,
            isMask: false,
            isPay: false,
            isPayShow: false,
            isDownShow: false,
            isDownLoad: '',
            uid: '',    
            token: '',
            all_money: '',
            own_group_num: 0, 
            own_cp_num: 0, 
            local_currency: 0,  
            btc: '',
            eth: '', 
            trx: '',        
            btc_money: '',
            btcm_money: '',
            usdt_money: '',
            eth_money: '',  
            trx_money: '', 
            user: {
                avatar: require('@/assets/icon_my_tx.jpg'),
                phone:'', 
                invite_code: '',
                level: 'V0'            
            },
            changMoney: '$0.00',
            wheelImg: [],
            newsArr: [],
            timer: null,
            swiperOption: {
                loop:true,
                autoplay:{
    　　　　　　　　delay: 5000,
    　　　　　　　　stopOnLastSlide: false,
    　　　　　　　　/* 触摸滑动后是否继续轮播 */
    　　　　　　　　disableOnInteraction: false
    　　　　　　},
                on:{
                    click: ()=>{   
                        let swiper = this.$refs.mySwiper.$swiper; 
                        let i = JSON.parse(swiper.clickedSlide.attributes['data-index'].nodeValue);                        
                        vm.bannerGo(i);                                                
                    }
                },    
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true,
                },     
            }, 
            swiperOption2: {
                notNextTick: true,
                loop: true,
                direction: "vertical", 
                autoplay:{
    　　　　　　　　delay: 5000,    　　　　　　　　
　　　　　　     },
                on:{
                    click: ()=>{   
                        let swiper = this.$refs.mySwiper2.$swiper; 
                        let i = JSON.parse(swiper.clickedSlide.attributes['data-index'].nodeValue);                        
                        vm.getAlert(i);                                                
                    }
                },              
            }, 
            swiperOption3: {
                slidesPerView: 'auto',
                spaceBetween: 10,            
            },      
        }
    },
    created(){      
        vm = this; 
        let zcShow = localStorage.getItem('zcShow');   
        this.isDownLoad = sessionStorage.getItem('isDownLoad');       
        if(zcShow == null || zcShow == 'true'){
            localStorage.setItem('zcShow',true);
            this.isShow = true
        }else{
            localStorage.setItem('zcShow',false);
            this.isShow = false
        }   
    },
    mounted() {        
        let uid = this.uid = localStorage.getItem('uid');
        let token = this.token =localStorage.getItem('token'); 
        this.init(uid,token); 
        this.getWheelimg();
        this.getNews();  
        this.getMemberInfo();
        this.getNewestcurrency();
        this.getSmrz();
        this.check();
        if(this.isDownLoad){
            this.isDownShow = false
        }else{
            this.isDownShow = false
        } 
        this.timer = setInterval(()=>{
            this.getNewestcurrency()
        },3000);        
    }, 
    methods: {
        check(){
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/Member/checkMoneyPass',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){ 
                    this.isMask = false;                  
                    this.isPay = false;              
                }else{
                    this.isMask = false;
                    this.isPay = true;                     
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },      
        getGroupInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/member/getGroupInfo',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    this.own_group_num = resData.own_group_num;
                    this.own_cp_num = resData.own_cp_num;
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },       
        getWheelimg(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/index/wheelimgIndex',params).then((res) => { 
                if(res.data.code == 200){
                    this.wheelImg = res.data.data; 
                }else{
                    this.$router.push('/login')                   
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },     
        init(uid,token){
            let params = {
                uid: uid,
                token: token
            }
            this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){                    
                    this.user = {
                        username: resData.username,
                        invite_code: resData.invite_code,
                        level: resData.level                    
                    }                    
                    localStorage.setItem('invite_code',resData.invite_code);                    
                }else{
                    this.$router.push('/login')
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },
        getMemberInfo(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/member/getMemberInfo',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    this.all_money = resData.all_money; 
                    this.btc_money = resData.btc_money;   
                    this.btcm_money = resData.btcm_money; 
                    this.eth_money = resData.eth_money;   
                    this.usdt_money = resData.usdt_money; 
                    this.trx_money = resData.trx_money || 0.0000;              
                }else{
                    this.$router.push('/login')                
                }
            }).catch(function(err){
                console.log(err);                
            })      
        },  
        getNewestcurrency(){
            let params = {
                uid: this.uid,
                token: this.token
            }          
            this.$ajax.post('/api/miningmachine/newestcurrency',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){                    
                    this.local_currency = resData.local_currency;                   
                    this.btc = resData.btc;
                    this.eth = resData.eth;
                    this.trx = resData.trx;
                    this.all_money = (parseFloat(this.btc_money * resData.btc) + parseFloat(this.btcm_money * resData.local_currency) + parseFloat(this.eth_money * resData.eth) + parseFloat(this.usdt_money) + parseFloat(this.trx_money * resData.trx)).toFixed(4);
                }else{
                    this.$router.push('/login');                 
                }
            }).catch(function(err){
                console.log(err);                
            })     
        },
        getSmrz(){//实名认证状态
            let params = {
                uid: this.uid,
                token: this.token
            }
            this.$ajax.post('/api/member/trueVerifiedStatus',params).then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){
                    if(resData == '' || resData == null){
                        this.isMask = false;
                        this.isSmrz = true;                                                                  
                    }else{  
                         if(resData.is_verified == 0 || resData.is_verified == 2){
                             this.isMask = false;
                             this.isSmrz = true;
                         }else{
                             this.isMask = false;
                             this.isSmrz = false;
                         }
                    }                    
                }else{
                    this.$router.push('/login')                
                }
            }).catch(function(err){
                console.log(err)
            })
        },  
        tibi(){
             if(this.isSmrz){
                this.isMask = true;
                this.isShowSmrz = true;
                return false;
            }else{
                this.isMask = false;
                this.isShowSmrz = false;
                if(this.isPay){
                    this.isMask = true;
                    this.isPayShow = true;
                    return false;
                }else{
                    this.isMask = false;
                    this.isPayShow = false;
                    this.$router.push('/tibi')
                }
            }            
        },  
        duiHuang(){
            this.$router.push('/kjmbSelect')
        },  
        getNews(){
            let params = {               
                page: 1,
                limit: 5
            }  
            this.$ajax.post('/api/index/announIndex',params).then((res) => {                
                let resData = res.data.data; 
                if(res.data.code == 200){
                    if(resData.length > 0){
                        this.newsArr = resData;
                    }else{
                        this.newsArr = []
                    }                               
                }
            }).catch(function(err){
                console.log(err)
            })           
        }, 
        bannerGo(i){                 
            let id = this.wheelImg[i].id; 
            let content = this.wheelImg[i].content; 
            if(content){
                this.$router.push({name:'bannerDetail',params:{id:id}});
            }			
        },
        getAlert(i){ 
            let id = this.newsArr[i].id; 
			this.$router.push({name:'newsDetail',params:{id:id}});
        },
        change(){
            this.isShow = !this.isShow;            
            localStorage.setItem('zcShow',this.isShow)
        },
        exit(){
            localStorage.setItem('token','');
            localStorage.setItem('uid','');
            sessionStorage.clear();
            this.$nextTick(function(){
                this.$router.push('/login')
            })
        },
        sign(){
            this.$router.push('/sign')
        },
        smrzSure(){
            this.$router.push('/smrz')
        },
        smrzClose(){
            this.isMask = false;
            this.isShowSmrz = false;
        },  
        paySetClose(){
            this.isMask = false;
            this.isPayShow = false;
        },   
        jump(id){            
            switch(id){
                case 0://个人信息
                    this.$router.push('/about');
                    break;
                case 1://签到
                    this.$router.push('/sign');
                    break;
                case 2://持币生息
                    this.$router.push('/cbsx');
                    break;
                case 3://资金明细                
                    this.$router.push('/capitalDetails');
                    break;
                case 4://实名认证
                    this.$router.push('/smrz');
                    break;
                case 5://我的订单                
                    this.$router.push('/myOrder');
                    break;
                case 6://消息中心
                    this.$router.push('/news');
                    break; 
                case 7://设置
                    this.$router.push('/set');
                    break; 
                case 8://资产
                    this.$router.push('/zc');
                    break;
                case 9://兑换
                    this.$router.push('/duihuang');
                    break;
                case 10://联系客服
                    this.$router.push('/onlineService');
                    break;
                default:
                   this.$router.push('/index');
                   break; 
            }
        },
        zcJump(type,bz,ye,zhje){ 
            this.$router.push('zcmx?type='+type+'&bz='+bz+'&ye='+ye+'&zhje='+zhje)
        },
        payJump(){
            this.isPay = false;
            this.isMask = false;
            this.$router.push('/ModifyCashPwd');
        },
        close(){           
            if(this.isDownLoad != null){
                this.isDownShow = false;
                sessionStorage.removeItem('isDownLoad');               
            }else{
                this.isDownShow = false;
                sessionStorage.setItem('isDownLoad',true);
            }                         
        },
    },
    beforeDestroy(){
        clearInterval(this.timer);        
        this.timer = null;        
    },
    filters: {        
        toFixed: function(val){           
            return val.toFixed(4)
        },
        testSplit: function(val){
            let len = 20;
            if (val.length >= len) {
                return val.substring(0, len) + "...";
            }else{
                return val;
            }
        },
        filterName: function(str){
            let len = 12;  
            if(str){
                if(str.length > len) {
                    return str.substr(0,3) + '****' + str.substr(parseInt(str.split('').length/2+1),str.split('').length)
                }else{
                    return str;
                }
            }      
            
        }
    },
    components:{
        navBar,
        Swiper,
        SwiperSlide,
    }
}
</script>
<style scoped>
    .cont-box{
        position: absolute;
        top: 0;
        bottom: 1.2rem;
        width: 100%;
        height: auto;
        padding: 0 .1rem;
        background: url('../assets/element-background.png') no-repeat center center;  
        background-size: cover;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: .8rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .36rem;
        line-height: .8rem;   
        box-sizing: border-box;   
        background: #0e1530;
        text-align: center;
    } 
    .head .icon{
        position: absolute;
        right: .24rem;
        top: 50%;
        width: .42rem;
        height: .42rem;
        margin-top: -.21rem;
    }
    .photo-box{
        position: relative;
        display: flex;
        align-items: center;
        padding: .38rem 0 .34rem;
    }
    .photo-box .photo{
        width: .88rem;
        margin-right: .24rem;
        border-radius: .1rem;
    }
    .photo-box .photo-info{
        flex: 1;
    }
    .photo-box .photo-info .t1{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: .32rem;
    }
    .photo-box .photo-info .t1 .level{
        padding-left: .06rem;
        font-size: .28rem;
    }
    .photo-box .photo-info .t1 .img{
        margin-left: .1rem;
        width: .36rem;
        height: .36rem;
    }
    .photo-box .photo-info .t2{
        padding-top: .2rem;
        color: #d7d7d7;
        font-size: .28rem;
    }
    .photo-box .icon{
        position: absolute;
        top: .38rem;
        right: 0;
        width: .4rem;
        height: .36rem;
    }
    .item-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: .7rem;
    }
    .item-wrap .item-box{
        width: 3.36rem;
        padding: .3rem .36rem .4rem;
        background: url('./../assets/tm.png') no-repeat right center;
        background-size: 100% 100%;
        box-sizing: border-box;
    }
    .item-wrap .item-box2{        
        background: url('./../assets/Performance.png') no-repeat right center;
        background-size: 100% 100%;
    }
    .item-wrap .num{
        color: #fff;
        font-size: .48rem;
    }
    .item-wrap .num .small{
        font-size: .32rem;
    }
    .item-wrap .text{
        padding-top: .16rem;
        color: #d7d7d7;
        font-size: .28rem;
    }
    .banner-box{
        position: relative;
        width: 100%;
        height: 3rem;        
    }
    .banner-box .banner{
        width: 100%;
        height: 3rem;
    }
    .banner-box .title{
        position: absolute;
        bottom: .4rem;
        width: 100%;
        height: .6rem;
        padding: 0 .2rem;
        color: #fff;
        line-height: .6rem;
        font-size: .24rem;  
        box-sizing: border-box;      
        text-align: center;
    }
    .tips{
        padding: .64rem 0 .68rem;
        font-size: .36rem;
    }  
    .list-box{
        display: flex;
        /* align-items: center; */
        flex-wrap: wrap;
        /* padding: 0 .42rem;              */
    }
    .list-box .list{    
        width: 33.33%;   
        margin-bottom: .5rem;
        color: #fff;
        font-size: .24rem;    
        text-align: center;   
    }
    .list-box .list:last-child{
        border-bottom: none;
    }
    .list-box .list .list-text{
        flex: 1;
        margin-top: .3rem;
    }
    .list-box .list .icon{
        height: .64rem; 
    }
    .list-box .list .arrow{
        width: .16rem;
        height: .3rem;           
    }
    .btn-box{
        padding: .26rem;
    }
    .btn-box .btn{
        width: 100%;
        height: .7rem;
        color: #fff;
        font-size: .28rem;
        border-radius: 4px;
        background: #1a243f;
        text-align: center;
    }
    .notice-box{
        display: flex;
        align-items: center;  
        height: .8rem;    
        margin: .2rem 0;
        /* padding: 0 .44rem;          */
        border-radius: .4rem;
    }    
    .notice-box .icon{
        width: .38rem;
        height: .38rem;
    }
    .notice-box .cont{
        position: relative;
        flex: 1;
        height: .8rem;
        padding: 0 .32rem;
        color: #fff;
        line-height: .8rem;
        font-size: .28rem;
        overflow: hidden;
    }
    .notice-box .cont .notice-scroll{
        height: .8rem;
        overflow: hidden;
    }
    .notice-box .arrow{
        width: .14rem;
        height: .28rem;
    }
    .zc-wrap{
        display: flex;
        flex-flow: nowrap;        
        /* align-items: center; */
        margin-top: .24rem;
        overflow-x: auto;
    }
    .zc-box{    
        flex-shrink: 0;
        width: 5.74rem;        
        padding: .42rem .5rem .42rem .68rem;
        margin-right: .22rem;
        color: #fff;
        font-size: .24rem;
        border-left: .04rem solid #fff;
        border-radius: 0 .1rem .1rem 0;       
        background: rgba(0, 0, 0, .3);
        box-sizing: border-box;
    }
    .zc-box .zc-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .zc-box .icon{
        width: .42rem;       
    }
    .zc-box .price{
        display: flex;
        align-items: center;
        padding-top: .5rem;
        color: #fff;
        font-size: .36rem;
    }
    .zc-box .price .input{
        width: auto;
        color: #fff;
        font-size: .48rem;
        background: transparent;
    }
    .zc-box .small{
        flex: 1;
        padding-left: .12rem;
        font-size: .3rem;
    }
    .item-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: .32rem 0 .48rem;
    }
    .item-box .item{
        width: 2.2rem;
        height: .7rem;        
        border-radius: .1rem;
        color: #fff;
        font-size: .24rem;
        line-height: .7rem;
        background: rgba(53, 87, 153, .2);
        text-align: center;
    }
    .zc-wrap .list{  
        position: relative;   
        width: 5.74rem;
        display: flex; 
        flex-shrink: 0;
        align-items: center;
        margin-right: .22rem;
        padding: .18rem .26rem .16rem .36rem;
        color: #fff;
        font-size: .24rem;
        border-left: .04rem solid #44CFFF;
        border-radius: 0 .1rem .1rem 0;       
        background: rgba(26, 36, 63, .2);
        box-sizing: border-box;
    }   
    .zc-wrap .list2{
        border-left: .04rem solid #56c0e5;        
    }
    .zc-wrap .list3{
        border-left: .04rem solid #1D9783;
        background: rgba(29, 151, 131,.1);
    }
    .zc-wrap .list4{
         border-left: .04rem solid #EF9300;
         background: rgba(239, 147, 0, .1);
    } 
    .zc-wrap .list5{
         border-left: .04rem solid #8b8b8b;
         background: rgba(139, 139, 139,.1);
    } 
    .zc-wrap .list6{
         border-left: .04rem solid #b81f1f;
         background: rgba(184, 31, 31,.1);
    } 
    .zc-wrap .list .arrow{
        width: .12rem;
        height: .24rem;
    }
    .zc-wrap .list .img-box{
        display: flex;
        align-items: center;
    }
    .zc-wrap .list .img{
        width: .62rem;
        height: .62rem;
    }
    .zc-wrap .list .title{
        width: 1rem;
        padding: 0 .28rem 0 .22rem;
        color: #EF9400;
        font-size: .34rem;
    }
    .zc-wrap .list .title2{
        color: #8c8c8c;
    }
    .zc-wrap .list .title.gdcc{
        color: #56c0e5;
    }
    .zc-wrap .list .info-box{
        flex: 1;        
        color: #fff;
        font-size: .24rem;
    }    
    .zc-wrap .list .info-box .title{
        color: #fff;
        font-size: .28rem;
    }    
    .zc-wrap .list .info-box .title.t1{
        color: #EF9300;
    }
    .zc-wrap .list .info-box .title.t2{
        color: #56c0e5;
    }
    .zc-wrap .list .info-box .title.t3{
        color: #56c0e5;
    }
    .zc-wrap .list .info-box .title.t4{
        color: #1D9783;
    }
    .zc-wrap .list .info-box .title.eth{
        color: #8b8b8b;
    }
    .zc-wrap .list .info-box .trx{
        color: #b81f1f;
    }
    .zc-wrap .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
    }
    .zc-wrap .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
        margin-top: .24rem;
    }    
    .zc-wrap .list .info-box .text1{
        width: 1.8rem;        
    }
    .zc-wrap .list .info-box .text2{
        flex: 1;
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }    
    .alert-wrap2{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: rgba(26, 36, 64,.9);
        border-radius: .2rem; 
        transform: translateY(-50%);       
    }
    .alert-wrap2 .tips{
        padding: 0 .44rem .44rem;
        color: #D1D1D1;
        font-size: .24rem;
        text-align: center;
    }    
    .alert-wrap2 .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap2 .btn-box .btn{
        width: 50%;
        height: .9rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box .reset{
        background: #4F608E;
        border-radius: 0 0 0 .2rem;
    }
    .alert-wrap2 .btn-box .sure{
        background: #677DB9;
        border-radius: 0 0 .2rem 0;
    }
    .swiper-slide {               
        /* width: 83%; */
    }    
    .alert-pay{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;        
        background: #1A2440;
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-pay .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-pay .close{
        position: absolute;
        right: .16rem;
        top: .2rem;
        width: .3rem;
    }
    .alert-pay .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-pay .cont{
        max-height: 6rem;
        padding: 0 .8rem .72rem .72rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-pay{
        background: rgba(26 ,36, 63,.9);
    }
    .alert-pay .alert-head{
        padding: .5rem .4rem;
        font-size: .28rem;
        border-bottom: 1px solid #858585;
    }
    .alert-pay .alert-btn{
        padding: .3rem 0;
        color: #2CAADE;
        font-size: .32rem;
        text-align: center;
    }
    .download-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        left: 2%;
        bottom: 1.2rem;
        z-index: 10000;
        width: 96%;
        height: 1.2rem; 
        padding: 0 .1rem; 
        border-radius: 4px;      
        background: rgba(51, 129, 213,1);
        box-sizing: border-box;
    }
    .download-box .logo{
        width: .5rem;
        height: .5rem;
    }
    .download-box .text-box .t1{
        font-size: .26rem;
        margin-bottom: .08rem;
    }
    .download-box .text-box{
        flex: 1;
        margin: 0 .1rem;
        color: #fff;
        font-size: .24rem;
    }
    .download-box .btn{     
        margin-right: .3rem;   
        padding: .1rem;
        color: #000;
        font-size: .24rem;
        border-radius: 4px;
        background: #fff;
        text-align: center;
    }    
    .download-box .btn-close{
        position: absolute;
        right: .06rem;
        top: .06rem;
        z-index: 999;
        width: .28rem;
        height: .28rem;
    }
</style>
<style lang="">
    .banner-box .swiper-pagination-bullet{
        width: .4rem;
        height: .04rem;
        border-radius: .2rem;
    }
    .banner-box .swiper-pagination-bullet{
        background: #2CAADE;
        opacity: 1;
    }
    .banner-box .swiper-pagination-bullet-active{
        background: #fff;
    }    
</style>


// WEBPACK FOOTER //
// src/pages/user.vue